import React from 'react';

import {
    createOidcAuthenticationComponent,
    createAuthorization,
    createDecoratedRoute,
    Spinner,
} from '@cp-shared-19/frontend-ui';

import { identityBrokerErrorPagePath, registrationPagePath } from 'components/navigation/paths';
import { CpDataApi } from 'cp-xhr';
import { RedirectWithParams } from '../utils/redirectWithParams';
import { IdentityBrokerErrorType } from 'components/error-pages/identity-broker-error';
import { getUserRegistryStatusEndpoint, UserRegistryStatus } from 'cpes-common';

export const getOidcErrorType = () => {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get('errorType') as IdentityBrokerErrorType | null;
};

const getRedirectPathOnMissingAuthorization = () => {
    const errorType = getOidcErrorType();
    return errorType ? identityBrokerErrorPagePath() : registrationPagePath();
};

export const getErrorPagePathWithErrorType = (errorType: string) =>
    identityBrokerErrorPagePath() + `?errorType=${errorType}`;

const Authentication = createOidcAuthenticationComponent({
    onMissingAuthentication: <RedirectWithParams to={getRedirectPathOnMissingAuthorization()} />,
});

const authDataProvider = async (): Promise<{ isAuthorized: boolean }> => {
    try {
        const { data: registrationData } = await CpDataApi.get<UserRegistryStatus>(getUserRegistryStatusEndpoint());
        return { isAuthorized: registrationData.isRegistered };
    } catch {
        return { isAuthorized: false };
    }
};

const { Authorization: UserRegistrationAuthorization } = createAuthorization({
    displayName: 'UserRegistrationAuthorization',
    authorizationDataProvider: authDataProvider,
    onMissingAuthorization: <RedirectWithParams to={getRedirectPathOnMissingAuthorization()} />,
    onLoading: <Spinner center />,
    onError: <RedirectWithParams to={getRedirectPathOnMissingAuthorization()} />,
});

export const AuthenticatedRoute = createDecoratedRoute('AuthenticatedRoute', Authentication);
export const AuthorizedRoute = createDecoratedRoute('AuthorizedRoute', Authentication, UserRegistrationAuthorization);
